<template>
  <v-dialog v-model="allDialog" width="400" class="login_container">
    <div class="login mx-auto" style="width: 400px; background: white;">
      <div class="d-flex justify-start align-center flex-column">
        <div
          class="pa-5 text-left"
          style="
            font-size: 20px;
            font-weight: bold;
            width: 100%;
            text-align: left;
          "
        >
          {{ $i18n.t("login.sign_in") }}
        </div>
        <div class="py-0" style="width: 100%;">
          <v-form ref="login_form" v-model="valid" class="px-4 py-2">
            <v-text-field
              v-model="user.email"
              prepend-inner-icon="mdi-account"
              name="login"
              :label="$i18n.t('login.Please_enter_email_address')"
              type="email"
              :rules="[required, email]"
              required
              outlined
            />
            <v-text-field
              id="password"
              v-model="user.password"
              prepend-inner-icon="mdi-lock"
              name="password"
              :label="$i18n.t('login.Please_enter_your_password')"
              :rules="[required, counter]"
              required
              outlined
              :type="isShowPassword ? 'text' : 'password'"
            >
              <v-fade-transition slot="append" mode="out-in">
                <v-icon
                  :key="`icon-${isShowPassword}`"
                  @click="isShowPassword = !isShowPassword"
                  v-text="isShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                />
              </v-fade-transition>
            </v-text-field>
            <div class="d-flex flex-column-reverse all-center">
              <div class="text-center" style="width: 100%;">
                <v-dialog v-model="dialog" width="400">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="#3f57bb"
                      style="width: 100%;"
                      class="white--text"
                      @click="getPic"
                    >
                      {{ $i18n.t("login.sign_in") }}
                    </v-btn>
                  </template>

                  <v-card style="margin-right: 1px;">
                    <v-card-title
                      class="headline grey lighten-2 all-center"
                      primary-title
                    >
                      {{ $i18n.t("login.Please_click_on_each_other") }}:
                      {{ tips[0] }} {{ tips[1] }} {{ tips[2] }} {{ tips[3] }}
                    </v-card-title>

                    <v-card-text class="all-center" style="padding: 10px;">
                      <div
                        style="
                          position: relative;
                          background-color: #333;
                          width: 300px;
                          height: 200px;
                        "
                      >
                        <img :src="imgSrc" alt="" />
                        <div
                          @click="getPosition"
                          style="
                            position: absolute;
                            top: 0;
                            right: 0;
                            width: 100%;
                            height: 100%;
                            background-color: transparent;
                          "
                        >
                          <div
                            :style="{
                              top: position.y + 'px',
                              left: position.x + 'px',
                            }"
                            v-for="(position, index) in positionArray"
                            :key="position.x + position.y"
                            class="verity-number all-center"
                          >
                            {{ index + 1 }}
                          </div>
                        </div>
                      </div>
                    </v-card-text>

                    <v-divider />

                    <v-card-actions>
                      <v-btn color="primary" text @click="refreshPic">
                        {{ $i18n.t("login.refresh") }}
                      </v-btn>
                      <v-spacer />
                      <v-btn color="primary" text @click="dialog = false">
                        {{ $i18n.t("login.finish") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </div>
          </v-form>
        </div>
      </div>
      <v-dialog v-model="activeDialog" width="400">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            {{ $i18n.t("personal.Activate your account") }}
          </v-card-title>

          <v-card-text class="font-weight-black">
            {{
              $i18n.t(
                "personal.We will send a link to your email to activate your account, please click the link in your mailbox within 10 minutes to activate the account, if you do not receive mail please contact Computer Science"
              )
            }}
          </v-card-text>

          <v-card-actions>
            <div class="d-flex justify-space-between align-center flex-grow-1">
              <v-btn color="primary" text @click="activeAccount">
                {{ $i18n.t("personal.send") }}
              </v-btn>
              <v-btn color="primary" text @click="activeDialog = false">
                {{ $i18n.t("personal.close") }}
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div
        class="d-flex justify-space-between align-center px-5 pb-2"
        style="width: 100%;"
      >
        <div
          @click="toRegister"
          class="ma-0 pa-0"
          style="
            width: 50%;
            margin-top: 5px !important;
            color: #3f57bb;
            font-size: 14px;
            cursor: pointer;
            text-align: left;
          "
        >
          {{ $i18n.t("login.sign_up") }}
        </div>

        <div
          @click="toFindPassword"
          class="ma-0 pa-0"
          style="
            min-width: 120px;
            margin-top: 5px !important;
            text-align: right;
            color: #3f57bb;
            cursor: pointer;
            font-size: 14px;
          "
        >
          {{ $i18n.t("login.Forget your password") }}
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  data: () => ({
    allDialog: false,
    dialog: false,
    valid: false,
    imgSrc: "",
    sessionId: "",
    tips: [],
    user: {
      email: "",
      password: "",
    },
    positionArray: [],
    showPic: false,
    remember_me: false,
    isShowPassword: false,
    autoLogin: false,
    signInFail: false,
    activeDialog: false,
  }),
  computed: {
    ...mapState(["rememberMe", "loading", "showSignIn"]),
  },
  mounted() {
    this.allDialog = this.showSignIn;
    document.onkeyup = (e) => {
      if (e.key === "Enter") {
        if (this.valid) {
          this.getPic();
        }
      }
    };
  },
  methods: {
    ...mapMutations([
      "SET_REMEMBER_ME",
      "SET_SIGN_IN",
      "SET_SHOW_SIGNIN",
      "SET_SHOW_SIGNUP",
    ]),
    ...mapActions([
      "signIn",
      "findPassword",
      "checkVerify",
      "getVerify",
      "active",
      "reactiveAccount",
    ]),
    toRegister() {
      this.SET_SHOW_SIGNIN(false);
      this.SET_SHOW_SIGNUP(true);
    },
    activeAccount() {
      this.activeDialog = false;
      this.reactiveAccount({ email: this.user.email });
    },
    toFindPassword() {
      this.SET_SHOW_SIGNIN(false);
      this.$router.push("/find_password");
    },
    closeLogin() {
      this.SET_SHOW_SIGNIN(false);
    },
    getPic() {
      // 获取验证码图片 渲染
      if (this.valid) {
        this.dialog = true;
        this.getVerify().then((res) => {
          this.imgSrc = "data:image/png;base64," + res.data.data.base64String;
          this.sessionId = res.data.data.id;
          this.tips = res.data.data.tips;
          this.showPic = true;
          this.positionArray = [];
        });
      } else {
        this.dialog = false;
      }
    },
    refreshPic() {
      this.positionArray = [];
      this.getPic();
    },
    getPosition(e) {
      let position = { x: e.offsetX, y: e.offsetY };
      if (this.positionArray.length < 4) {
        this.positionArray.push(position);
        if (this.positionArray.length === 4) {

          this.dialog = false;
          this.checkVerify({
            sessionId: this.sessionId,
            addresses: [...this.positionArray],
          }).then((res) => {
            if (res.data.code === 200) {
              let password = this.$md5(this.user.password);
              this.signIn({ email: this.user.email, password })
                .then((res) => {
                  if (res.data.code === 200) {
                    this.$router.push("/");
                    this.closeLogin();
                  } else if (res.data.code === 601) {
                    // 未激活时，要重新显示发送邮件的地址
                    this.activeDialog = true;
                  } else if (res.data.code === 500) {
                    this.signInFail = true;
                  }
                })
                .catch(() => {
                  this.signInFail = true;
                });
            }
          });
        }
      }
    },
    required(value) {
      return !!value || this.$i18n.t("login.What is required");
    },
    email(value) {
      const pattern = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      return (
        pattern.test(value) ||
        this.$i18n.t("login.Please enter the correct mailbox")
      );
    },
    counter(value) {
      return (
        value.length >= 8 ||
        this.$i18n.t("login.Cannot be less than 8 characters")
      );
    },
  },
  watch: {
    autoLogin: {
      handler(newV, ) {
        this.SET_REMEMBER_ME(newV);
      },
    },
    allDialog: {
      handler(newV) {
        if (!newV) {
          this.SET_SHOW_SIGNIN(false);
        }
      },
    },
  },
};
</script>
<style lang="scss">
@import "../utils/common";

.login_container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;

  .v-label.theme--light {
    font-size: 14px !important;
  }

  .v-input--selection-controls {
    margin-top: 0 !important;
  }

  .theme--light.v-btn.v-btn--disabled {
    background-color: #3f57bb !important;
    color: white !important;
  }

  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #3f57bb !important;
    opacity: 0.8;
  }
}

.verity-number {
  width: 24px;
  height: 24px;
  border: 1px solid #3f57bb;
  background: white;
  border-radius: 50%;
  position: absolute;
  margin-top: -12px;
  margin-left: -12px;
}
</style>
